import { useEffect } from "react";
const useEventListenerOutside = (handler, eventType, refs) => {
  useEffect(() => {
    const documents = /* @__PURE__ */ new Set([document]);
    const listener = (event) => {
      if (!refs.some((ref) => ref.current && ref.current.contains(event.target))) handler(event);
    };
    refs.forEach((ref) => {
      if (ref.current && ref.current.ownerDocument) {
        const parentDocument = ref.current.ownerDocument;
        if (parentDocument !== document) documents.add(parentDocument);
      }
    });
    documents.forEach((document2) => document2.addEventListener(eventType, listener));
    return () => {
      documents.forEach((document2) => document2.removeEventListener(eventType, listener));
    };
  }, [refs, eventType, handler]);
};
export {
  useEventListenerOutside as default
};
//# sourceMappingURL=useEventListenerOutside.es.js.map
